/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
const { selectDesktop } = Slices.appSlice;
const { createProfile, selectLoginStatus, sendOtp } = Slices.authSlice;
import Header from '../../components/Header';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import LanguageButton from '../../components/LanguageButton';
import { Badge } from '../../components/Icons';
import PopUpHeading from '../../components/PopUpHeading';
import PizzaHutLogo from '../../brands/phd/logo';
import Loader from '../../components/Loader';
import css from './index.module.scss';
const { selectCurrentCountry } = Slices.profileSlice;
import CreateProfile from '../../components/CreateProfile';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@material-ui/core';
import DrawerPwa from '../../components/DrawerPwa';
import DialogBox from '../../components/DialogBox';
const { selectCountryValidations } = Slices.configSlice;
import DialogContent from '@material-ui/core/DialogContent';

function Guest({ path, locale, retUrl = '/login' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const isLoggedIn = useSelector(selectLoginStatus);
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [errorObj, setErrorObj] = useState(null);
  const [otherError, setOtherError] = useState('');
  if (isLoggedIn) {
    navigate(-1);
  }
  const countryName = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const isDesktop = useSelector(selectDesktop);
  const dispatch = useDispatch();
  // const guestLoginData = useSelector(selectGuestLogin);
  // eslint:fix guestLoginData is defined but is never used

  // const isProfileCreated = useSelector(selectProfileStatus);

  const [name, setName] = useState('');
  const [cCode] = useState(countryValidations.defaultCCode);
  const [phnNo, setPhnNo] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const [email, setEmail] = useState('');

  const [drawerstate, setDrawerState] = useState(false);
  const [numberExistMsg, setNumberExistMsg] = useState('');

  const handleNameInput = (e) => {
    setName(e.target.value.replace(/[^a-zA-Z ]/g, ''));
    validationName(e.target.value.replace(/[^a-zA-Z ]/g, ''));
  };
  const validationName = (nameInput) => {
    let name = nameInput;
    var pattern = /^(?:[a-zA-Z\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF]))/;
    if (name.match(pattern)) {
      setNameError(false);
    } else {
      setNameError(true);
    }

    if (name === '') {
      setNameError(true);
    }
  };

  const handlePhoneInput = (e) => {
    setPhnNo(e.target.value);
  };
  const handleEmailInput = (e) => {
    const { value } = e.target;
    setEmail(value);
    validationEmail(value);
  };
  const validationEmail = (emailInput) => {
    let email = emailInput;
    let pattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (email.match(pattern)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }

    if (email === '') {
      setEmailError(true);
    }
  };
  const handleCreateProfile = (e) => {
    setPageLoader(true);
    const phone = phnNo.replace(cCode, '');
    if (phone.match(countryValidations.phnRegex)) {
      const cartLocation = { ...location, href: location.origin, pathname: `/${intl.locale}/cart` };
      dispatch(
        createProfile({ cCode, createProfileVia: 'GUEST', phnNo: phone, email, name, isGuest: 0 })
      ).then((resp) => {
        if (resp.payload?.data?.type === 'PROCEED_WITH_PHONE_NO') {
          const msg = intl.formatMessage({ id: 'guest_mobileExist' }).replace(`{mobileNo}`, phnNo);
          setNumberExistMsg(msg);
          setErrorObj(resp.payload.data);
          setDrawerState(true);
        } else if (resp.payload?.data?.type === 'LOGIN') {
          navigate(`/${intl.locale}/verifyOTPGuest`, {
            replace: true,
            state: {
              otpId: resp.payload.data?.data?.otpId,
              phnNo: resp.payload.data?.data?.phnNo,
              email: resp.payload.data?.data?.email,
              isEmailVerify: false,
              oldLocation: JSON.parse(JSON.stringify(cartLocation)),
            },
          });
        } else if (resp.payload?.data?.type === 'USER_EMAIL_ALREADY_EXIST') {
          const msg = intl.formatMessage({ id: 'guest_emailExist' }).replace(`{email}`, email);
          setErrorObj(resp.payload.data);
          setNumberExistMsg(msg);
          setDrawerState(true);
        } else {
          if (resp.error) {
            setOtherError(resp.error?.message);
          } else {
            const msg = resp.payload?.data?.message;
            setErrorObj(resp.payload?.data);
            setNumberExistMsg(msg);
            setDrawerState(true);
            setOtherError(msg);
          }
        }
        setPageLoader(true);
      });
    } else {
      setPageLoader(true);
      setPhoneError(true);
    }
  };

  // useEffect(() => {
  //   if (guestLoginData.type === 'LOGIN') {
  //     const result = guestLoginData.data;

  //   } else if (guestLoginData.type === 'PROCEED_WITH_PHONE_NO') {
  //     setDrawerState(true);
  //     const msg = intl.formatMessage({ id: 'guest_mobileExist' }).replace(`{mobileNo}`, phnNo);
  //     setNumberExistMsg(msg);
  //   }
  // }, [guestLoginData, intl, location, navigate, phnNo]);

  const handleClickAway = () => {
    setDrawerState(false);
  };

  const clickChangeNo = () => {
    if (errorObj?.type === 'USER_EMAIL_ALREADY_EXIST') {
      setDrawerState(false);
      setEmail('');
    } else {
      setDrawerState(false);
      setPhnNo('');
    }
  };

  const onProceedClick = () => {
    const phone = phnNo.replace(cCode, '');

    dispatch(
      sendOtp({
        cCode: cCode,
        phnNo: phone,
        sendOtpVia: 'OTP',
        country: countryName?.toUpperCase(),
      })
    )
      .then((resp) => {
        if (resp.meta.requestStatus === 'rejected') {
          console.log(resp.error);
        } else {
          navigate(`/${intl.locale}/verifyOTP`, {
            replace: true,
            state: {
              cCode: cCode,
              phnNo: phone,
              // component: state.component,
              retUrl: '/checkout',
              oldLocation: location?.state?.oldLocation,
            },
          });
        }
      })
      .catch((error) => {});
  };

  // const handleOnClose = () => {
  //   navigate('/cart');
  // };
  // eslint:fix handleOnClose is defined but is never used
  const onExitMemoized = React.useCallback(
    (e) => {
      navigate(-1);
    },
    [navigate]
  );
  const titleDesc = <FormattedMessage id="guest_filldetails" defaultMessage="Fill your details" />;
  const renderDrawerContent = () => {
    return (
      <div className={css.dialogInner}>
        <div className={css.topPos}>
          <PizzaHutLogo width="109" height="100" />
        </div>
        <div className={css.headerText}>
          <FormattedMessage id="guest_switchAccount" defaultMessage="Switch Account" />
        </div>
        <div className={css.errorDrawer}>
          <div className={css.error}>{numberExistMsg}</div>
          <div className={css.buttonContainer}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                clickChangeNo();
              }}
            >
              {errorObj?.type === 'USER_EMAIL_ALREADY_EXIST' ? (
                <FormattedMessage id="guest_changeEmail" defaultMessage="Change Email" />
              ) : (
                <FormattedMessage id="guest_changeNo" defaultMessage="Change No" />
              )}
            </Button>
            {errorObj?.type !== 'USER_EMAIL_ALREADY_EXIST' && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  onProceedClick();
                }}
              >
                <FormattedMessage id="guest_proceed" defaultMessage="Proceed" />
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={css.root}>
      {pageLoader && <Loader />}
      <Snackbar
        open={otherError !== '' ? true : false}
        autoHideDuration={6000}
        onClose={() => setOtherError('')}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={() => setOtherError('')} severity="error" sx={{ width: '100%' }}>
          {otherError}
        </Alert>
      </Snackbar>
      {!isDesktop ? (
        <Header
          icon={<FaArrowLeft onClick={onExitMemoized} />}
          title={titleDesc}
          actionButtons={[<LanguageButton />]}
          className={css.whiteBackground}
        />
      ) : (
        <>
          <PopUpHeading heading={titleDesc} onClose={onExitMemoized} />
        </>
      )}
      <CreateProfile
        isDesktop={isDesktop}
        name={name}
        emailError={emailError}
        nameError={nameError}
        handleNameInput={handleNameInput}
        phnNo={phnNo}
        handlePhoneInput={handlePhoneInput}
        email={email}
        phoneError={phoneError}
        handleEmailInput={handleEmailInput}
        handleCreateProfile={handleCreateProfile}
      />
      {isDesktop ? (
        <DialogBox title="" size="sm" isOpen={drawerstate} onClose={handleClickAway} page="login">
          <DialogContent dividers={true}>{renderDrawerContent()}</DialogContent>
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          className={css.pwadrwer}
          anchor="bottom"
          onClose={handleClickAway}
          open={drawerstate}
        >
          {renderDrawerContent()}
        </DrawerPwa>
      )}
    </div>
  );
}

export default Guest;
